<template>
  <div class="chartjs-container">
    <canvas :id="id" :height="height"></canvas>
  </div>
</template>

<script>
import Chart from 'chart.js/auto';
import { ref, onMounted, watch, onBeforeUnmount, nextTick } from 'vue';

export default {
  name: "BarChart",
  props: {
    id: {
      type: String,
      default: "bar-chart",
    },
    chartData: {
      type: Object,
      required: true,
    },
    chartOptions: {
      type: Object,
      default: () => ({}),
    },
    height: {
      type: String,
      default: "300",
    },
  },
  setup(props) {
    const chartInstance = ref(null);

    const initChart = () => {
      const ctx = document.getElementById(props.id)?.getContext("2d");
      if (ctx && props.chartData) {
        chartInstance.value = new Chart(ctx, {
          type: "bar",
          data: props.chartData,
          options: props.chartOptions,
        });
      }
    };

    const updateChart = () => {
      if (chartInstance.value) {
        chartInstance.value.data = props.chartData;
        chartInstance.value.options = props.chartOptions;
        chartInstance.value.update();
      }
    };

    onMounted(() => {
      initChart();
    });

    onBeforeUnmount(() => {
      if (chartInstance.value) {
        chartInstance.value.destroy();
      }
    });

    watch(() => props.chartData, () => {
      nextTick(() => {
        if (chartInstance.value) {
          updateChart();
        } else {
          initChart();
        }
      });
    }, { deep: true });

    watch(() => props.chartOptions, () => {
      nextTick(() => {
        if (chartInstance.value) {
          updateChart();
        }
      });
    }, { deep: true });

    return {
      chartInstance,
    };
  },
};
</script>

<style scoped>
.chartjs-container {
  position: relative;
  width: 100%;
  height: 100%;
}
</style>